export const formatPrice = (price?: number, currency?: string): string => {
  if (!price && !currency) {
    return null;
  }
  let formattedPrice = `${(price / 100).toFixed(2)}`;
  if (currency) {
    formattedPrice = `${currency} ${formattedPrice}`;
  }
  return formattedPrice;
};

export const capitalizeFirstLetters = (string: string): string =>
  string
    .toLowerCase()
    .split(' ')
    .map(s => s.charAt(0).toUpperCase() + s.substring(1))
    .join(' ');
